import api from './api';

export interface AiGenerator {
  id: number;
  name: string;
  description: string;
  icon: string;
  category: string;
  sortOrder: number;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface AiGeneratorPromptDetail {
  id: number;
  name: string;
  description: string;
  content: string;
  category: string;
  type?: string;
}

export interface AiGeneratorPromptUpdatePayload {
  name: string;
  description: string;
  content: string;
  password: string;
}

export const getAllGenerators = async (): Promise<AiGenerator[]> => {
  try {
    const response: any = await api.get('/ai-generator');
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to load generators');
  } catch (error: any) {
    console.error('getAllGenerators failed:', error);
    throw error;
  }
};

export const getGeneratorById = async (id: number): Promise<AiGenerator> => {
  try {
    const response: any = await api.get(`/ai-generator/${id}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to load generator');
  } catch (error: any) {
    console.error('getGeneratorById failed:', error);
    throw error;
  }
};

export const accessGeneratorPrompt = async (
  id: number,
  password: string
): Promise<AiGeneratorPromptDetail> => {
  try {
    const response: any = await api.post(`/ai-generator/${id}/prompt/access`, { password });
    if (response.success) {
      return {
        ...response.data,
        type: 'official',
      };
    }
    throw new Error(response.message || 'Failed to access generator prompt');
  } catch (error: any) {
    console.error('accessGeneratorPrompt failed:', error);
    throw error;
  }
};

export const updateGeneratorPrompt = async (
  id: number,
  payload: AiGeneratorPromptUpdatePayload
): Promise<AiGeneratorPromptDetail> => {
  try {
    const response: any = await api.put(`/ai-generator/${id}/prompt`, payload);
    if (response.success) {
      return {
        ...response.data,
        type: 'official',
      };
    }
    throw new Error(response.message || 'Failed to update generator prompt');
  } catch (error: any) {
    console.error('updateGeneratorPrompt failed:', error);
    throw error;
  }
};
